import { useEffect, useState, useRef } from "react";
import { Strophe, $pres, $msg } from "strophe.js";
import images from "../../../../../../../../utilities/images/images";
import Avatarr from "./Avatar";
import "./Chatting.scss";
import Emoji from "./Emoji";
import Poll from "./poll/Poll";

const BOSH_SERVICE = "https://chat.motion.ac.in:7443/http-bind";
// const ROOM = "global-1@conference.chat.motion.ac.in";

function ChatComponent({ streamingDetails, isLive }) {
  const { username, password, name, chatroom ,privateChatroom} = streamingDetails;
  const [connection, setConnection] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [openEmoji, setOpenEmoji] = useState(false);
  const [selectedEmoji, setSelectedEmoji] = useState(null);
  const msgContainerRef = useRef(null);
  const inputRef = useRef(null);
  const [showPoll, setShowPoll] = useState(false);



  useEffect(() => {
    const conn = new Strophe.Connection(BOSH_SERVICE);
    setConnection(conn);

    conn.connect(username, password, (status) => {
      if (status === Strophe.Status.CONNECTED) {
        console.log("Connected");

        // Once connected, join the room
        conn.send($pres().c("priority").t("5"));
        conn.send(
          $pres({
            to: chatroom + "/" + name,
          }).c("x", { xmlns: "http://jabber.org/protocol/muc" }),
        );

        // Listen for incoming messages
        conn.addHandler(onMessage, null, "message", "groupchat");
      }
    });
  }, []);

  useEffect(() => {
    if (msgContainerRef.current) {
      msgContainerRef.current.scrollTop = msgContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const onMessage = (msg) => {

    const isMyMessage =
      Strophe.getResourceFromJid(msg.getAttribute("from")) === name;

    const from = Strophe.getResourceFromJid(msg.getAttribute("from"));

    const body = Strophe.getText(msg.getElementsByTagName("body")[0]);

    const delayElement = msg.getElementsByTagName("delay")[0];
    const timestamp = delayElement ? delayElement.getAttribute("stamp") : null;
    let timeString = "";
    if (timestamp) {
      const date = new Date(timestamp);
      timeString = date.toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit', second: '2-digit' });
    }
    
    
    setMessages((prevMessages) => [
      ...prevMessages,
      { from: from, body:body , isMyMessage: isMyMessage ,timestamp:timeString},
    ]);

    return true;
  };

  const inputOnchangeHandler = (event) => {
    setInputMessage(event.target.value);
  };

  const handleEnterKey = (event) => {
    if (event.key === "Enter") {
      sendGroupMessage();
    }
  };

  function sendGroupMessage() {
    if (inputMessage.length === 0) {
      alert("Please Enter Message");
      return;
    }

    var message = $msg({
      to: chatroom,
      type: "groupchat",
    })
      .c("body")
      .t(inputMessage);

    connection.send(message);

    setInputMessage("");
  }

  function handleClickPollIcon() {
    console.log("");
    setShowPoll(true);
  }

  console.log("messages", messages);
  return (
    <div className="chatbox-container">
      <div className="chatbox-wrapper">
        <header>
          <img src={images.chatIcon} alt="chatIcon" />
          <h3 className="chat-text">Chat</h3>
          <h3 onClick={() => setShowPoll(!showPoll)} className="poll-text">
            Poll
          </h3>
        </header>

        <section className="message-container" ref={msgContainerRef}>
          {messages?.map((msg) => {
            let isMyMessage = msg.from === name;
            let splitAdmin;
    if (msg.body?.includes("##_SPLIT_##")) {
      splitAdmin = msg.body.split("##_SPLIT_##");
    } else {
     
     
      splitAdmin = [msg.from,msg.body]; // Set a default format (adjust as needed)
            }

           
            
            if (msg.from === name) {
              return (
                <div className={"msg-list"}>
                  <div className={"avatar-and-name my"}>
                    <div className="user-name">{msg.timestamp}</div>
                    <div className="user-name">You</div>
                    <div className="avatar">
                      {" "}
                      {msg.from ?
                        <Avatarr name={msg.from} /> : ""
                      }{" "}
                    </div>
                  </div>

                  <div className="msg-container2">
                    <div className={"user-msg my-msg"} dangerouslySetInnerHTML={{ __html: msg.body }} />
                  </div>
                </div>
              );
            } else {
              
              if (splitAdmin[0] === password.toLowerCase() || splitAdmin[0] === "ALL") {
                return (
                 <div className={"msg-list"}>
                   <div className={isMyMessage ? "name" : "avatar-and-name"}>
                     <div className="avatar">
                       {" "}
                       {msg.from  ?
                         <Avatarr name={msg.from} /> : ""
                      
                       }{" "}
                     </div>
                      <div className="user-name">{msg.from}</div>
                      <div className="user-name">{msg.timestamp}</div>
                   </div>

                    <div className="msg-container1">
                      
                     <div className={"user-msg"} dangerouslySetInnerHTML={{ __html: splitAdmin[1]}}></div>
                   </div>
                 </div>
               );

              }
            }

          })}
        </section>



        {isLive && streamingDetails?.chat && (
          <section className="input-send-container">
            <div className="input-emoji-wrapper">
              <div className="emoji-wrapper">
                <div className="emoji" onClick={() => setOpenEmoji(!openEmoji)}>
                  <img src={images.emojiIcon} alt="emoji-icon" />
                </div>
                {openEmoji && (
                  <>
                    <Emoji
                      openEmoji={openEmoji}
                      selectedEmoji={inputMessage}
                      setSelectedEmoji={setInputMessage}
                      setOpenEmoji={setOpenEmoji}
                      inputRef={inputRef}
                      className="emoji-inner-wrapper"
                    />
                    <div
                      className="close-btn"
                      onClick={() => setOpenEmoji(!openEmoji)}
                    >
                      &#x2715;
                    </div>
                  </>
                )}
              </div>

              <div className="msg-input">
                <input
                  // type="text"
                  value={inputMessage}
                  placeholder="Type here..."
                  onChange={inputOnchangeHandler}
                  onKeyDown={handleEnterKey}
                  ref={inputRef}
                />
              </div>
            </div>

            <div className="send-icon " onClick={sendGroupMessage}>
              <img src={images.sendBtn} alt="send-btn" />
            </div>
          </section>
        )}
      </div>

      <Poll
        streamingDetails={streamingDetails}
        showPoll={showPoll}
        setShowPoll={setShowPoll}
      />
    </div>
  );
}

export default ChatComponent;
